import { lazy } from "react";

const Signin = lazy(() => import("./Signin"));

const Error404 = lazy(() => import("./Error"));
const DownloadDocument = lazy(() => import("./DownloadDocument"));
const DownloadEtatCompte = lazy(() => import("./DownloadEtatCompte"));
const Sso = lazy(() => import("./Sso"));
const DownloadAbonnementCard = lazy(() => import("./DownloadAbonnementCard"));

const sessionsRoutes = [
  {
    path: "/session/signin",
    component: Signin
  },
  {
    path: "/session/sso",
    component: Sso
  },
  {
    path: "/session/document/download/:id/:token",
    component: DownloadDocument
  },
  {
    path: "/session/etat_compte/download/:begin/:end/:id/:token",
    component: DownloadEtatCompte
  },
  {
    path: "/session/abonnement_card/download/:id/:token",
    component: DownloadAbonnementCard
  },
  {
    path: "/session/404",
    component: Error404
  }
];

export default sessionsRoutes;
